import React from 'react';
import Field from '../../Field';
import { Check } from '../../FormControls';
import s from './eventDrawer.module.css';

// The two descriptions. The private one is visible only to the teacher even
// when the event itself is public, which is the whole point of having two.

export default function DescriptionSection({ form, set, shape }) {
  return (
    <div className={s.section}>
      <h3 className={s.sectionTitle}>Additional Information</h3>

      <Field label="Public Description">
        <textarea
          rows={3} className={s.input}
          value={form.publicDescription}
          onChange={(e) => set('publicDescription', e.target.value)}
        />
      </Field>
      <Check
        label="Show public description directly on calendar"
        checked={form.showPublicDescription}
        onChange={(e) => set('showPublicDescription', e.target.checked)}
      />

      {shape.privateDescription ? (
        <div className={s.spacedTight}>
          <Field label="Private Description" hint="Visible only to you, even if the event is public">
            <textarea
              rows={3} className={s.input}
              value={form.privateDescription}
              onChange={(e) => set('privateDescription', e.target.value)}
            />
          </Field>
        </div>
      ) : null}
    </div>
  );
}
